import {Route, Routes,useParams} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {AuthLayout} from './AuthLayout'
import {SignUp} from './components/SignUp'
import { LandingPage } from './components/LandingPage'
import {IntermediatePage} from './components/IntermediatePage'
import {RedirectPage} from './components/RedirectPage'

function ProfilePage() {
  // Get the userId param from the URL.
  let { userId } = useParams();
  // ...
} 

const AuthPage = () => (
  

  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='registration' element={<Registration />} />
      {/* <Route path='forgot-password' element={<ForgotPassword />} /> */}
      <Route path='signUp' element={<SignUp />} />
      <Route path='registration-page' element={<LandingPage />} />
      <Route path='terms-conditions' element={<IntermediatePage />} />
      <Route path ='get-new-user/:uid' element ={<RedirectPage />} />

      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
